module.exports = __webpack_public_path__ + "img/null_log_top.29a4283b.png";